import {datadogRum} from '@datadog/browser-rum';
import {FeatureFlagResponse} from 'domain/usecases/private/check-features/get-check-features';
import {makeLocalStorageAdapter} from 'main/factories/cache';
import {makeGetCheckFeatures} from 'main/factories/usecases/private/check-features/get-check-features';
import {CachedFeatureFlags} from './types';
import {FEATURE_FLAG_CACHE_TIME, FEATURE_FLAGS_STORAGE_KEY} from './constants';

async function fetchFeatureFlags(): Promise<FeatureFlagResponse[]> {
	const validLocalStorageCache = getLocalStorageFeatureFlags();

	if (validLocalStorageCache) {
		return validLocalStorageCache.data;
	}

	try {
		const response = await makeGetCheckFeatures().get();

		const cacheData: CachedFeatureFlags = {
			data: response.content,
			timestamp: Date.now(),
		};

		makeLocalStorageAdapter<CachedFeatureFlags>().set(FEATURE_FLAGS_STORAGE_KEY, cacheData);

		return response.content;
	} catch (error) {
		datadogRum.addError(error, {context: 'feature-flags'});
		throw new Error('Failed to fetch feature flags');
	}
}

function getLocalStorageFeatureFlags() {
	const storedFlags =
		makeLocalStorageAdapter<CachedFeatureFlags>().get(FEATURE_FLAGS_STORAGE_KEY);
	const isCacheValid =
		storedFlags && Date.now() - storedFlags.timestamp <= FEATURE_FLAG_CACHE_TIME;

	return isCacheValid ? storedFlags : undefined;
}

export {fetchFeatureFlags, getLocalStorageFeatureFlags};
